import React from "react";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import { Box } from "@mui/material";
import { post } from "../api/setting/actions";
import HotStateIcon from "../assets/icon/hot-state";
import WarmStateIcon from "../assets/icon/warm-state";
import ColdStateIcon from "../assets/icon/cold-state";

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const EMAIL_OPTIONAL_REGEX =
  /^(?:$|(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/;

export const MOBILE_REGEX = /^\+\d{1,3}\d{10}$/;

// test

export const handleBGColor = (leadState: any, mode: string) => {
  switch (leadState) {
    case "hot":
      return mode === "dark" ? "#460809" : "#FFF0F0";
    case "warm":
      return mode === "dark" ? "#432004" : "#FFF7ED";
    case "cold":
      return mode === "dark" ? "#162456" : "#EFF6FF";
    default:
      return "#07A4FC";
  }
};

export const getUserOnlineStatus = (
  lastUpdated: number,
  lastActivity: number
): "online" | "offline" | "away" => {
  const currentTimestamp = new Date().getTime();
  // console.log("new log", currentTimestamp, lastUpdated, lastActivity);
  if (!lastUpdated || !lastActivity) return "offline";
  if (currentTimestamp - lastUpdated >= 30000) {
    return "offline";
  } else {
    if (currentTimestamp - lastActivity >= 600000) {
      return "away";
    } else {
      return "online";
    }
  }
};

export const handleColor = (leadState: any, mode: string) => {
  switch (leadState) {
    case "hot":
      return mode === "dark" ? "#FB2C36" : "#E7000B";
    case "warm":
      return mode === "dark" ? "#F0B100" : "#F0B100";
    case "cold":
      return mode === "dark" ? "#2B7FFF" : "#2B7FFF";
    default:
      return "#2B7FFF";
  }
};

export const handleBackground = (leadState: string | undefined, search = false) => {
  if (search)
    return (
      <ManageSearchRoundedIcon fontSize="large" sx={{ alignItems: "center", display: "flex" }} />
    );
  return (
    // <Avatar
    //   sx={{ width: size === "large" ? 45 : 27, height: size === "large" ? 45 : 27 }}
    //   src={handleSrc(con?.leadState)}
    //   alt="cold-lead-state"
    // />
    <Box
      sx={{
        width: "31px",
        height: "31px",
        borderRadius: "50%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor:
        //   leadState === "hot" ? "#FEECEE" : leadState === "cold" ? "#E6F6FF" : "#FFF8E5",
      }}
    >
      {leadState === "hot" ? (
        <HotStateIcon sx={{ width: "15px", height: "20px" }} />
      ) : leadState === "cold" ? (
        <ColdStateIcon sx={{ width: "20px", height: "20px" }} />
      ) : (
        <WarmStateIcon sx={{ width: "20px", height: "20px" }} />
      )}
    </Box>
  );
};

export function formatNumber(num: { toLocaleString: () => any }) {
  if (!num && num !== "0") return "-";
  return num.toLocaleString();
}

export function removeTrailingZeros(num: { toString: () => string }) {
  if (!num) return "-";
  return `$${num
    ?.toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    .split(".")[0]
    .replace("$", "")}`;
}

export const handleCopyClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(function () {
      // console.log('Text copied to clipboard');
    })
    .catch(function (err) {
      console.error("Error copying text to clipboard", err);
    });
};

export const transformDays = (day: string) => {
  if (day === "fri") return "Friday";
  else if (day === "mon") return "Monday";
  else if (day === "sat") return "Saturday";
  else if (day === "sun") return "Sunday";
  else if (day === "thu") return "Thursday";
  else if (day === "tue") return "Tuesday";
  else if (day === "wed") return "Wednesday";
};

export const transformArrays = (workingHours: object, appointmentOnly: string) => {
  const generateData = Object.entries(workingHours).map(([key, value]: any) => {
    const [startTime, endTime] = value.split("-"); // Split the value
    let start = startTime.slice(0, -2) === "0" ? "0:00" : startTime.slice(0, -2); // Get the start time (without AM/PM)
    start = start.includes(":") ? start : start + ":00";
    let end = endTime.slice(0, -2) === "0" ? "0:00" : endTime.slice(0, -2); // Get the end time (without AM/PM)
    end = end.includes(":") ? end : end + ":00";
    const morning = startTime.slice(-2).toLowerCase(); // Get AM/PM for start
    const midnight = endTime.slice(-2).toLowerCase(); // Get AM/PM for end
    const closed = value === "0AM-0AM" ? true : false;
    return {
      start,
      end,
      morning,
      midnight,
      closed,
      day: key && transformDays(key),
    };
  });
  const appointmentDays = appointmentOnly?.split(",").map(transformDays);
  // check appointment_only
  return generateData.map((i) => {
    return {
      appointmentOnly: appointmentDays?.includes(i.day),
      ...i,
    };
  });
};

export const handleChangeFormat = (array: any[]) => {
  // Use map to create a new array with an added property
  const updatedArrays = array.map(({ start, end, morning, midnight, closed, ...rest }: any) => {
    let timeRange = null;
    if (closed) timeRange = "0AM-0AM";
    else timeRange = `${start}${morning.toUpperCase()}-${end}${midnight.toUpperCase()}`;
    return {
      ...rest, // Spread the existing properties
      timeRange, // Optional (if not closed)
    };
  });
  return updatedArrays;
};

export const handleName = (name: string | any) => {
  // Check if the input is a string
  if (typeof name !== "string") {
    return name?.charAt(0);
  }

  // Split the full name into first and last name
  const nameParts = name.trim().split(" ");

  // Check if the name has at least two parts
  if (nameParts.length < 2) {
    return name.charAt(0)?.toUpperCase() + name.charAt(1)?.toUpperCase();
  }

  // Get the first character of the first and last name
  const firstInitial = nameParts[0][0]?.toUpperCase();
  const lastInitial = nameParts[1][0]?.toUpperCase();

  // Return the initials
  return `${firstInitial}${lastInitial}`;
};

export function validateMobileNumber(number: string) {
  const regex = /^\+\d{1,3}\d{10}$/;
  return regex.test(number);
}

export function validateEmail(email: string) {
  const regex = EMAIL_REGEX;
  return regex.test(email);
}

export function formatPhoneNumber(number: string) {
  if (validateMobileNumber(number)) {
    // Remove any non-digit characters
    const cleaned = number.replace(/\D/g, "");
    // Check if the cleaned number has the expected length
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      const areaCode = cleaned.slice(1, 4);
      const centralOfficeCode = cleaned.slice(4, 7);
      const lineNumber = cleaned.slice(7);
      return `1 (${areaCode}) ${centralOfficeCode}-${lineNumber}`;
    } else {
      return number;
    }
  } else return number;
}

function convertDate(dateString: any) {
  // Split the date string into components
  const [year, month] = dateString.split("-").map(Number);
  // Array of month abbreviations
  const monthAbbreviations = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // Get the month abbreviation (subtracting 1 because months are zero-indexed)
  const monthAbbreviation = monthAbbreviations[month - 1];
  // Format the output
  return `Holidays for ${year} - ${monthAbbreviation}`;
}

const groupBy = (data: any) => {
  return Object.entries(data).reduce((accumulator: any, [key, value]: any) => {
    const newValue = { ...value, id: key }; // Create a new object with the added id
    const date = value.date;
    // Extract the month and year from the date
    const [month, , year] = date.split("/").map(Number);
    // Create a month key in the format "YYYY - month abbreviation"
    const monthKey = `${year}-${month}`;
    if (!accumulator[monthKey]) {
      accumulator[monthKey] = [];
    }

    // Create a status key based on appointment_only and closed
    let statusKey = "";
    if (newValue.appointmentOnly) statusKey = "appointmentOnly";
    else if (newValue.timeRange === "0AM-0AM") statusKey = "closed";
    else statusKey = "other";

    if (!accumulator[monthKey][statusKey]) {
      accumulator[monthKey][statusKey] = [];
    }

    accumulator[monthKey][statusKey].push(newValue);
    return accumulator;
  }, {}); //initial state
};

// export async function fetchData(query: any) {
//   const path = `${import.meta.env.VITE_BASE_URL}/salesagent-searchEngine?search=${query}`;

//   try {
//     const response = await get(path);

//     if (!response) {
//       throw new Error("Network response was not ok ");
//     }

//     const data = response;
//     return data || [];
//   } catch (error) {
//     console.error("There was a problem with the fetch operation:", error);
//   }
// }

export async function fetchData(query: any, uid: string) {
  const path = `${import.meta.env.VITE_BASE_URL}/salesagent-elastic-search`;

  const dataBody = { query_text: query, uid, from_: 0, size_: 20 };

  try {
    const response = await post(dataBody, path);

    if (!response) {
      throw new Error("Network response was not ok ");
    }

    const data = response;
    return data.docs || [];
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
}

export const convertTo24Hour = (time: string, period: string) => {
  const [hours, minutes] = time.split(":").map(Number);
  if (!hours) return "";
  let convertedHours = hours; // Use let for hours since it may change

  if (period.toLowerCase() === "pm" && convertedHours < 12) {
    convertedHours += 12;
  } else if (period.toLowerCase() === "am" && convertedHours === 12) {
    convertedHours = 0;
  }

  // Format hours and minutes to ensure two digits
  const formattedHours = String(convertedHours).padStart(2, "0");
  let formattedMinutes = String(minutes).padStart(2, "0");
  if (formattedMinutes === "undefined") formattedMinutes = "";

  if (formattedMinutes) return `${formattedHours || ""}:${formattedMinutes || ""}`;
  else return `${formattedHours}`;
};

export const handleAddQueryParam = (newValue: string) => {
  // Update the URL without triggering a rerender
  const newUrl = newValue;
  window.history.pushState({ path: newUrl }, "", newUrl);
};

export function customizeSourceName(source: string) {
  switch (source) {
    case "OFFERUP":
      return "OfferUp";
    case "CARFAX, INC":
      return source.slice(0, 6); // remove , INC
    case "widget":
      return "Drivee AI Chat Widget";
    case "FBMessenger":
      return "Facebook";
    case "IGMessenger":
      return "Instagram";
    default:
      return source;
  }
}

export const getCampaignStatus = (statusNum: number) => {
  switch (statusNum) {
    case -1:
      return "not verified";
    case 0:
      return "pending";
    case 1:
      return "completed";
    case 2:
      return "scheduled";
    case 3:
      return "running";
    case 4:
      return "canceled";
  }
};

export const getCampaignStatusBG = (statusNum: number) => {
  switch (statusNum) {
    case 0:
      return "#E69900";
    case 1:
      return "#23A46C";
    case 2:
      return "#A629CC";
    case 3:
      return "#297EFF";
    case 4:
      return "#EF4444";
  }
};

export const getCampaignStatusColor = (statusNum: number) => {
  switch (statusNum) {
    case 0:
      return "#ffa700";
    case 1:
      return "#0070ff";
    case 2:
      return "#9c19ff";
    case 3:
      return "#1C9864";
    case 4:
      return "#ff0808";
  }
};

export function generateUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16 | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const generateClock = (startHour = 1, endHour = 13) => {
  const clockData = [];
  for (let hour = startHour; hour < endHour; hour++) {
    for (const minutes of [0, 30]) {
      const time = `${hour}:${minutes.toString().padStart(2, "0")}`;
      clockData.push(time);
    }
  }
  return clockData;
};

const getTokenFromUrl = (status: string) => {
  if (status === "search") {
    const params = new URLSearchParams(location.search);
    return params?.get("token");
  } else if (status === "pathname") {
    const pathname = window.location.pathname;
    const cleanedPathname = pathname.replace("/", "").trim();
    return cleanedPathname;
  }
};

const transformName = (lead: any) => {
  let updatedLeadName = "";
  switch (lead) {
    case "ace_spfi":
      updatedLeadName = "Acespfi";
      break;
    case "appointments":
      updatedLeadName = "Appointments";
      break;
    case "auto_list":
      updatedLeadName = "َAuto list";
      break;
    case "auto_source":
      updatedLeadName = "َAuto source";
      break;
    case "buy_sell_auto_mart":
      updatedLeadName = "Buy sell automart";
      break;
    case "car_soup":
      updatedLeadName = "Car soup";
      break;
    case "car_zing":
      updatedLeadName = "Car zing";
      break;
    case "cars":
      updatedLeadName = "Cars";
      break;
    case "cars_for_sale":
      updatedLeadName = "Cars for sale";
      break;
    case "cars_inc":
      updatedLeadName = "Cars inc";
      break;
    case "claz":
      updatedLeadName = "Claz";
      break;
    case "craige_list":
      updatedLeadName = "Craige list";
      break;
    case "dealer_assistan_request":
      updatedLeadName = "Dealer assistant request";
      break;
    case "facebook_marketplacet":
      updatedLeadName = "Facebook market placet";
      break;
    case "hot_leads":
      updatedLeadName = "Hot leads";
      break;
    case "first_responder":
      updatedLeadName = "First responder";
      break;
    case "james_edition":
      updatedLeadName = "James edition";
      break;
    case "kbb_listing":
      updatedLeadName = "Kbb listing";
      break;
    case "manual_entry":
      updatedLeadName = "Manual entry";
      break;
    case "msn_autos":
      updatedLeadName = "Msn autos";
      break;
    case "offer_up":
      updatedLeadName = "Offer up";
      break;
    case "true_cars":
      updatedLeadName = "True cars";
      break;
    case "v12":
      updatedLeadName = "V12";
      break;
    default:
      break;
  }
  return updatedLeadName;
};
export const reactQuillUtils1 = [
  [{ header: [1, 2, false] }],
  ["bold", "italic", "underline"],
  ["link", "image"], // Ensure 'image' is included here
  ["clean"], // Remove formatting button
];

export const reactQuillUtils2 = [
  [{ header: [1, 2, false] }],
  ["bold", "italic", "underline"],
  ["link"], // Ensure 'image' is included here
  ["clean"], // Remove formatting button
];

// generate id for email
const regex = /<([^@]+)@/;
const handleGenerateId = (input: any) => {
  const match = input.match(regex);
  if (match) {
    const result = match[1];
    return result;
  } else {
    return input;
  }
};

function areObjectsEqual(obj1: any, obj2: any) {
  // Check if both are objects
  if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null) {
    return false;
  }

  // Get keys of both objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check each key and value
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false; // Values are different
    }
  }

  return true; // All keys and values match
}

function areArraysEqual(arr1: any[], arr2: any[]) {
  if (arr1.length !== arr2.length) return false;
  return arr1.sort().every((value, index) => areObjectsEqual(value, arr2.sort()[index]));
}

export {
  convertDate,
  groupBy,
  transformName,
  getTokenFromUrl,
  handleGenerateId,
  areObjectsEqual,
  areArraysEqual,
};
